import React, { useContext } from 'react';
import { Badge, Layout } from 'antd'
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import DrawerMenu from '../menu/DrawerMenu';
import SideMenu from '../menu/SideMenu';
import Loader from '../loader/Loader';
import ProfileOptions from '../menu/ProfileOptions';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { AlertOutlined } from '@ant-design/icons';
import { useEffect } from 'react';


const { Header, Content } = Layout;

const InternalLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()


  const {
    mobile_mode,
    loadBadges,
  } = useContext(GeneralContext)

  useEffect(() => {
    loadBadges()
  }, [location])

  const handleOnClickBadges = () => {
    navigate(`/users?filter=${true}`)
  }

  return (
    <Layout style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'row' }}>

      <Loader />

      {mobile_mode ? <DrawerMenu /> : <SideMenu />}

      <Layout className="site-layout" style={{ background: "white", display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <Header style={{ background: 'white', padding: 0, borderBottom: '2px solid #14532D', boxShadow: '0px -15px 39px #14532D' }}>

          <div style={{ display: 'flex', flexDirection: 'row', flex: 1, justifyContent: 'flex-end', alignItems: 'center', height: '100%', gap: 15 }}>
            {/* <NotificationDrawer /> */}
            
              {mobile_mode ? '' : <div style={{ "fontSize": "17px", "fontWeight": "bold", "marginRight": "5px", "height": "35px", "marginTop": "13px", "lineHeight": "35px" }}/>}
              <div  style={{ marginRight: 0, marginTop: 3, cursor: 'pointer' }}>
                <div style={{ zIndex: 100 }} onClick={handleOnClickBadges}>
                  <Badge   overflowCount={9} offset={[-5, 5]} size="small">
                    <AlertOutlined style={{ fontSize: 24 }} />
                  </Badge>
                </div>
              </div>

            <ProfileOptions />
          </div>

        </Header>

        <div
          style={
            mobile_mode ? {
              width: '100vw',
              height: '100vh',
              flex: 1,
              margin: '16px 0px',
              overflow: 'scroll'
            } : {
              width: 'unset',
              height: 'unset',
              flex: 1,
              // marginBottom: 16,
              padding: "0px !important",
              overflow: 'scroll'
              // height: 'calc(100% - 32px)'
            }
          }
        >
          <Content
            className="site-layout-background"
            style={{
              flex: 1,
              height: '100%',
              padding: mobile_mode ? 8 : 16,
              width: mobile_mode ? '100%' : 'unset',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Outlet />
          </Content>
        </div>
      </Layout>
    </Layout >
  )
}

export default InternalLayout;
